import { getWorkflowLogById } from '@/redux/actions/gravityActions';

// Poll only the selected unfinished log's metadata; never poll its S3 output.
const pollWorkflowLogFinalization = ({ workflowId, workflowLogId }) => {
  let stopped = false;
  let timer;

  const poll = async () => {
    try {
      await getWorkflowLogById({ workflowId, workflowLogId, silent: true });
    } catch (error) {
      console.warn('Failed to refresh workflow log finalization.', { workflowId, workflowLogId, message: error?.message });
    }
    if (!stopped) {
      timer = setTimeout(poll, 10000);
    }
  };

  timer = setTimeout(poll, 10000);
  return () => {
    stopped = true;
    clearTimeout(timer);
  };
};

export default pollWorkflowLogFinalization;
